export async function copyLinkPageButton(selector) {
  const buttons = document.querySelectorAll(selector);
  buttons.forEach(item => {
    item.addEventListener('click', async () => {
      const link = item.dataset.copyLink;
      try {
        await navigator.clipboard.writeText(link);
        item.classList.add('success');
        setTimeout(() => {
          item.classList.remove('success');
        }, 2000);
      } catch (error) {
        console.error(error.message);
      }
    });
  });
}

export function sharePage(el) {
  const elements = document.querySelectorAll(el);
  elements.forEach(element => {
    const button = element.querySelector('.dke_sharepage__icon');
    const container = element.querySelector('.dke_sharepage__links');
    const blogItem = element.closest('.dke_blog-item, .article-item');
    const bodySize = {
      width: document.body.clientWidth,
      height: document.body.clientHeight,
    };

    const containerPosition = {
      bottom: container.getBoundingClientRect().bottom + window.scrollY,
      right: container.getBoundingClientRect().right,
    };

    if (containerPosition.bottom > bodySize.height) {
      container.classList.add('bottom');
    }

    if (containerPosition.right > bodySize.width) {
      container.classList.add('right');
    }

    button.addEventListener('click', () => {
      if (window.innerWidth < 992 && navigator.share) {
        const link = button.dataset.copyLink;
        const title = button.dataset.copyTitle;
        navigator
          .share({
            title: title,
            url: link,
          })
          .catch(console.error);
      } else {
        container.classList.toggle('active');
        element.classList.toggle('active');
        if (blogItem && container.classList.contains('active')) {
          blogItem.classList.add('sharepage-open');
        }
      }
    });

    if (element.closest('.dke_blog-item, .article-item')) {
      blogItem.addEventListener('transitionend', () => {
        if (!container.classList.contains('active')) {
          blogItem.classList.remove('sharepage-open');
        }
      });
    }

    element.addEventListener('click', e => {
      e.stopPropagation();
    });

    document.addEventListener('click', () => {
      container.classList.remove('active');
      element.classList.remove('active');
    });
  });
}
